/**
 * OAuth2CallbackPage — OAuth2 授权码回调（gitman 模式）
 * 后端 callback 302 到本页 ?code=<一次性兑换码>，前端用 code 换回真正的 token
 * 独立于 Layout 渲染
 */
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import {
  Spinner,
  Title1,
  Subtitle1,
  Button,
  MessageBar,
  MessageBarBody,
} from '@fluentui/react-components'
import { useAuthStore } from '@/store/auth'
import { oauthApi } from '@/api/oauth'
import { ROUTES } from '@/routes'

export default function OAuth2CallbackPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const setSession = useAuthStore((s) => s.setSession)
  const [error, setError] = useState<string | null>(null)
  const handled = useRef(false)

  useEffect(() => {
    if (handled.current) return
    handled.current = true

    const code = params.get('code')

    const run = async () => {
      if (!code) {
        setError('缺少授权码（code）')
        return
      }
      try {
        const data = await oauthApi.exchange(code)
        setSession(data.token, data.user)
        navigate(ROUTES.HOME, { replace: true })
      } catch (e) {
        setError(e instanceof Error ? e.message : 'OAuth2 登录失败')
      }
    }
    run()
  }, [params, navigate, setSession])

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'center', justifyContent: 'center', background: '#f0f2f5' }}>
        <MessageBar intent="error" style={{ maxWidth: 480 }}>
          <MessageBarBody>
            <Title1>OAuth2 登录失败</Title1>
            <Subtitle1>{error}</Subtitle1>
          </MessageBarBody>
        </MessageBar>
        <Button appearance="primary" onClick={() => navigate(ROUTES.LOGIN)}>返回登录</Button>
      </div>
    )
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'center', justifyContent: 'center', background: '#f0f2f5' }}>
      <Spinner size="large" />
      <span style={{ color: '#8c8c8c' }}>正在完成 OAuth2 登录...</span>
    </div>
  )
}
